/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Delete_Confirm_PromptInputs */

const en_general_delete_confirm_prompt = /** @type {(inputs: General_Delete_Confirm_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please type the name to confirm.`)
};

const de_general_delete_confirm_prompt = /** @type {(inputs: General_Delete_Confirm_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte geben Sie den Namen zur Bestätigung ein.`)
};

/**
* | output |
* | --- |
* | "Please type the name to confirm." |
*
* @param {General_Delete_Confirm_PromptInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_delete_confirm_prompt = /** @type {((inputs?: General_Delete_Confirm_PromptInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Delete_Confirm_PromptInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_delete_confirm_prompt(inputs)
	return de_general_delete_confirm_prompt(inputs)
});